import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../../libs/widgetUtilities';

import Popover from '../Popover/Popover';
import EventFilterEditor from '../../events-list/EventFilterEditor';
import NavigationHistory from '../../libs/NavigationHistory';

export class _EventsFilters extends React.Component {
  constructor(props) {
    super(props);
    const filters = props.user.preferences.eventsFiltersApp;
    /* When landing on this page directly, we redirect the user to the Events widget */
    const { location } = props.navigationHistory.history;
    if (
      !location.state ||
      location.state.filterIndex === undefined ||
      location.state.filterIndex >= filters.length
    )
      props.navigationHistory.goToWidgetFromPopover({
        pathname: props.linkUrlFor(`/events`)
      });
    else {
      this.filterIndex = props.location.state.filterIndex;
      this.editExistingFilter = props.location.state.editExistingFilter;
    }
    this.renderEventsFilters = this.renderEventsFilters.bind(this);
  }

  renderEventsFilters() {
    const { user } = this.props;
    return (
      <div tw="bg-silver-lighten-30 flex-grow">
        <EventFilterEditor
          {...this.props}
          filters={user.preferences.eventsFiltersApp}
          filterIndex={this.filterIndex}
          editExistingFilter={this.editExistingFilter}
        />
      </div>
    );
  }

  render() {
    const { location, history, navigationHistory } = this.props;
    /* Do not try to render the popover page when we are redirecting to the Events widget */
    if (this.filterIndex === undefined) return null;
    return (
      <Popover
        renderContent={this.renderEventsFilters}
        location={location}
        history={history}
        navigationHistory={navigationHistory}
      />
    );
  }
}

_EventsFilters.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    host: PropTypes.string,
    username: PropTypes.string,
    preferences: PropTypes.shape({
      eventsFiltersApp: PropTypes.arrayOf(PropTypes.shape({}))
    }).isRequired
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      filterIndex: PropTypes.number,
      editExistingFilter: PropTypes.bool
    })
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired,
  linkUrlFor: PropTypes.func.isRequired
};

export default withRouter(_EventsFilters);
